module.exports = __webpack_public_path__ + "static/img/暂无内容.6892fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/暂无内容.jpg
// module id = K9QD
// module chunks = 1